import React, {FocusEvent} from 'react'
//@ts-ignore
import {LoqateField} from '../loqate-field'
import {UseFormReturn} from 'react-hook-form'
import {AddressDetails} from '../../types/loqate'
import {BoxProps} from '../../vanilla'
import { Field } from '../../types/forms'

interface SearchForAddressLineFieldProps {
  form: UseFormReturn<any>
  field: Field
  isRegisterPage: boolean
  canEditAddressId: boolean
  inputGroupProps?: BoxProps<'input' | 'textarea'>
  showAsterisk?: boolean
}

/* Reusable component for Address Fields on Register page, My Addresses, Delivery page.  */
export const SearchForAddressLineField = (props: SearchForAddressLineFieldProps) => {
  const {form, field, inputGroupProps = {}, showAsterisk = false, isRegisterPage, canEditAddressId} = props

  const applyAddressToForm = (address: AddressDetails) => {
    form.clearErrors([
      'searchForAddress',
      'address1',
      'address2',
      'city',
      'stateCode',
      'postalCode',
      'addressId',
      'countryCode',
    ])

    form.setValue('searchForAddress', address.PostalCode)
    form.setValue('address1', address.Line1)
    form.setValue('address2', address.Line2 ?? '')
    form.setValue('city', address.City)
    form.setValue('stateCode', address.ProvinceName)
    form.setValue('postalCode', address.PostalCode)
    form.setValue('countryCode', address.CountryIso2.toUpperCase())

    if (isRegisterPage) {
      form.setValue('addressId', (address.Line1 ?? address.Line2).substring(0, 20))
    }
  }

  const handleBlurEvent = (e: FocusEvent<HTMLInputElement>) => {
    // If not register page disable based on custom pref
    if(isRegisterPage || canEditAddressId) form.setValue('addressId', (e.target.value).substring(0, 20))
  }

  return (
    <LoqateField
      field={field}
      onSearchValueChange={(searchValue) => form.setValue(field.name, searchValue)}
      setFoundedAddressToForm={applyAddressToForm}
      onBlur={handleBlurEvent}
      inputGroupProps={inputGroupProps}
      showAsterisk={showAsterisk}
    />
  )
}
